var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      !_vm.isLoading && _vm.getAgent
        ? [
            _c("DrawerApp", {
              staticClass: "hidden-sm-and-down",
              attrs: { user: _vm.getAgent, drawer: _vm.drawer },
              on: {
                "update:drawer": function ($event) {
                  _vm.drawer = $event
                },
              },
            }),
            _vm._v(" "),
            _c("Navbar", {
              staticClass: "hidden-lg-and-up hidden-md-and-up",
              attrs: {
                user: _vm.getAgent,
                clipped: _vm.clipped,
                title: _vm.title,
                drawer: _vm.drawer,
              },
              on: {
                "update:drawer": function ($event) {
                  _vm.drawer = $event
                },
              },
            }),
            _vm._v(" "),
            _vm.getAgentNotifications && _vm.getAgentNotifications.length
              ? _c("NotificationsBanner")
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-main",
              {
                staticClass: "sm-max-p-0",
                class: _vm.showStepsBanner ? "" : "sm-and-down-mt-56",
              },
              [
                _c(
                  "v-container",
                  { staticClass: "sm-max-p-0 mb-15 md-mb-0" },
                  [
                    _c(
                      "v-fade-transition",
                      { attrs: { mode: "out-in" } },
                      [_vm._t("default")],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.getAgent.helper_complete &&
            _vm.getAgent.role === _vm.$roles.ENTREPRENEUR
              ? _c("TutorialModal")
              : _vm._e(),
            _vm._v(" "),
            _c("FrequentQuestionsDrawer"),
            _vm._v(" "),
            _vm.getSelectedTicketId ? _c("TicketDetailDrawer") : _vm._e(),
            _vm._v(" "),
            _c("BottomNavigationApp", {
              staticClass: "hidden-lg-and-up hidden-md-and-up",
            }),
            _vm._v(" "),
            _vm.notification
              ? _c(
                  "v-snackbar",
                  {
                    attrs: {
                      bottom: "",
                      right: "",
                      "multi-line": "",
                      timeout: 6000,
                      elevation: "20",
                    },
                    model: {
                      value: _vm.showNotification,
                      callback: function ($$v) {
                        _vm.showNotification = $$v
                      },
                      expression: "showNotification",
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.notification.text) + "\n      "
                    ),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _vm.notification.link
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              primary: "",
                              icon: "",
                              to: _vm.notification.link,
                              target: "_blank",
                            },
                          },
                          [
                            _c("v-icon", { attrs: { dark: "", small: "" } }, [
                              _vm._v(" fas fa-external-link-alt "),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-0",
                        attrs: { primary: "", icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.showNotification = false
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { dark: "", small: "" } }, [
                          _vm._v(" fas fa-times "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : [_c("Loading")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }